import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUser_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUser_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  GetFlyRoleNames: any[];
  GetFlyRoleNames_dummy: any[];
  GetUserById: any;
  GetUserById_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  KullaniciSirketGetir: any[];
  KullaniciSirketGetir_dummy: any[];
  SirketSelectAll: any[];
  SirketSelectAll_dummy: any[];
  SplitStringBaknet: any[];
  SplitStringBaknet_dummy: any[];
  CreateUser: string;
  CreateUser_dummy: string;
  SaveUser: any;
  SaveUser_dummy: any;
  GetUserRoles: any[];
  GetUserRoles_dummy: any[];
  RemoveUserFromRole: boolean;
  RemoveUserFromRole_dummy: boolean;
  ForEach1: ItemModel;
  ForEach1_dummy: ItemModel;
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  ForEach2: Kuika.ThirdPartyApisCollection.Piece;
  ForEach2_dummy: Kuika.ThirdPartyApisCollection.Piece;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  isComp9544Visible: "visible" | "hidden";
  isCompuser_form_9544AuthorizationVisible: "visible" | "hidden";
}

export class User_Form_ScreenBase extends React.PureComponent<
  IUser_Form_ScreenProps,
  any
> {
  user_form_3353874_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "913b08cf-d908-4b8c-9f3b-50507d408297",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Kullanıcı Formu" },
        { Id: 2257187, PropertyName: "value", Value: "Kullanıcı" },
        { Id: 9359352, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 4185606, PropertyName: "value", Value: "Ad" },
        { Id: 8433475, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7536351, PropertyName: "value", Value: "Soyad" },
        { Id: 3800230, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 7465546, PropertyName: "value", Value: "Blokeli" },
        { Id: 8502781, PropertyName: "value", Value: "Roller" },
        { Id: 5618669, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 9885691, PropertyName: "value", Value: "Durum" },
        { Id: 7649061, PropertyName: "placeholder", Value: "15" },
        { Id: 5165664, PropertyName: "value", Value: "Cep Telefonu" },
        { Id: 6476179, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 8988830, PropertyName: "value", Value: "Sirket" },
        { Id: 3353874, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 729828, PropertyName: "label", Value: "Vazgeç" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach1: any[];
  ForEach2: any[];

  constructor(props) {
    super(props);
    this.user_form_9359352_value_kuikaTextInputRef = React.createRef();
    this.user_form_8433475_value_kuikaTextInputRef = React.createRef();
    this.user_form_3800230_value_kuikaTextInputRef = React.createRef();
    this.user_form_6476179_value_kuikaTextInputRef = React.createRef();
    this.user_form_3353874_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      GetFlyRoleNames: [],
      IfThenElse: false,
      KullaniciSirketGetir: [],
      SirketSelectAll: [],
      SplitStringBaknet: [],
      GetUserRoles: [],
      ForEach: false,
      SaveRecord_1: 0,
      isComp9544Visible: "hidden",
      isCompuser_form_9544AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("user_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.User_FormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompuser_form_9544AuthorizationVisible",
      ["41b245b2-8248-872c-382e-02ee2ce9c846", "FLYADMIN"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("user_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("user_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.User_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      user_form_9359352_value: this.state.GetUserById?.username ?? undefined,
      user_form_8433475_value: this.state.GetUserById?.firstName ?? undefined,
      user_form_3800230_value: this.state.GetUserById?.lastName ?? undefined,
      user_form_8002842_value: this.state.GetUserById?.isDisabled ?? undefined,
      user_form_5618669_value: this.state.GetUserById?.roleNames ?? undefined,
      user_form_7649061_value: this.state.GetUserById?.status ?? undefined,
      user_form_6476179_value: this.state.GetUserById?.phoneNumber ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  User_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetFlyRoleNames = result?.data.getFlyRoleNames;
    formVars.user_form_5618669_value = ReactSystemFunctions.toString(
      this,
      this.state.GetUserById?.roleNames
    );

    formVars.user_form_5618669_options = stateVars.GetFlyRoleNames;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormPageInit_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserById = result?.data.getUserById;
    formVars.user_form_9359352_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById?.username
    );
    formVars.user_form_8433475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById?.firstName
    );
    formVars.user_form_3800230_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById?.lastName
    );
    formVars.user_form_8002842_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById !== undefined
        ? stateVars.GetUserById?.length > 0
          ? stateVars.GetUserById[0].isDisabled
          : null
        : this.state.GetUserById?.length > 0
        ? this.state.GetUserById[0].isDisabled
        : null
    );
    formVars.user_form_5618669_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById?.roleNames
    );
    formVars.user_form_5618669_value = stateVars.GetUserById?.roleNames;
    formVars.user_form_7649061_value = ReactSystemFunctions.value(
      this,
      stateVars.GetUserById?.status
    );
    formVars.user_form_6476179_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserById?.phoneNumber
    );
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  User_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        ReactSystemFunctions.convertToTypeByName("0", "string")
      )
    ) {
      isErrorOccurred = await this.User_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KullaniciSirketGetir = result?.data.kullaniciSirketGetir;
    stateVars.SirketSelectAll = result?.data.sirketSelectAll;

    formVars.user_form_3353874_options = stateVars.SirketSelectAll;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_5618669 =
      stateVars.GetFlyRoleNames ?? this.state.GetFlyRoleNames;
    stateVars.dataSource_5618669 =
      stateVars.GetFlyRoleNames ?? this.state.GetFlyRoleNames;

    stateVars.dataSource_3353874 =
      stateVars.SirketSelectAll ?? this.state.SirketSelectAll;
    stateVars.dataSource_3353874 =
      stateVars.SirketSelectAll ?? this.state.SirketSelectAll;
    stateVars.isComp9544Visible =
      (ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) ||
        ReactSystemFunctions.isEqualTo(
          this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
          ReactSystemFunctions.convertToTypeByName("2", "string")
        )) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  User_FormComponent_159804_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "User_Form",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "547222",
      null,
      "left",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_729828_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      longStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_5618669_value",
            "value",
            "GetFlyRoleNames",
            "name",
            "name"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SplitStringBaknet = result?.data.splitStringBaknet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    KuikaAppManager.setNextRequestAudit(
      "0f294b7b-18d1-09c4-adac-e9644a8f03a9",
      "CreateUser",
      "User_Form",
      ""
    );

    stateVars.CreateUser = await ReactSystemFunctions.createUser(
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_9359352_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_8433475_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_3800230_value",
          "value",
          "",
          "",
          ""
        )
      ),
      true,
      "",
      ""
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      userName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_9359352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      firstName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_8433475_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      lastName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_3800230_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      roleNames_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      startingScreenId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "8fcffd5a-11f0-4e65-84b7-cdce09b86977",
          "Guid"
        ),
        "Guid"
      ),
      phoneNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_6476179_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dontSendEmail_0: ReactSystemFunctions.convertToTypeByName(
        true,
        "boolean"
      ),
      twoFactorAuthenticationType_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveUser = result?.data.saveUser;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.GetUserById?.username),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      isErrorOccurred = await this.User_FormComponent_9544_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.User_FormComponent_9544_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_9359352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserRoles = result?.data.getUserRoles;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_foreach3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.User_FormComponent_9544_onClick_foreach31_();
        resolve();
      });
    });
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_foreach31_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, this.ForEach1?.name),
        "_SystemAdmin"
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_9359352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.getMyUsername()
      )
    ) {
      KuikaAppManager.increaseServerRequestCount();

      KuikaAppManager.setNextRequestAudit(
        "eb893225-13da-c618-0354-5f06541bd63f",
        "RemoveUserFromRole",
        "User_Form",
        ""
      );

      stateVars.RemoveUserFromRole =
        await ReactSystemFunctions.removeUserFromRole(
          ReactSystemFunctions.value(this, this.ForEach1?.name),
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "user_form_9359352_value",
              "value",
              "",
              "",
              ""
            )
          )
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetUserRoles)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetUserRoles
      )) {
        this.ForEach1 = item;
        await this.User_FormComponent_9544_onClick_foreach3();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_foreach4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.User_FormComponent_9544_onClick_foreach41_();
        resolve();
      });
    });
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_foreach41_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, this.ForEach2?.str),
        true
      )
    ) {
      KuikaAppManager.increaseServerRequestCount();

      KuikaAppManager.setNextRequestAudit(
        "fffb5819-d1f5-47a6-a186-5c72d6987603",
        "AddUserToRole",
        "User_Form",
        ""
      );

      stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
        ReactSystemFunctions.value(this, this.ForEach2?.str),
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_9359352_value",
            "value",
            "",
            "",
            ""
          )
        )
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (
      ReactSystemFunctions.value(this, this.state.SplitStringBaknet)?.length
    ) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.SplitStringBaknet
      )) {
        this.ForEach2 = item;
        await this.User_FormComponent_9544_onClick_foreach4();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Sirket_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_3353874_value",
            "value",
            "SirketSelectAll",
            "sirket",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick5_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick6_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [547222] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.User_FormPageInit();
    }
  }
}
